import { OPEN_SELECTOR, CLOSE_SELECTOR } from './actions';


const defaultState = false;

export default function reducerSelectorContrato(state = defaultState, { type }) {
    switch (type) {
        case OPEN_SELECTOR: {
            return true;
        }
        case CLOSE_SELECTOR: {
            return false;
        }
        default:
            return state;
    }
}
